import React,{Component} from "react";
import {Link} from "react-router-dom";
import {Breadcrumb, BreadcrumbItem} from "reactstrap";
import Proptypes from "prop-types";

export default class BreadCrumbCompo extends Component {

    constructor(props){
        super(props);
        this.renderRoutes = this.renderRoutes.bind(this);
    }

    renderRoutes(){
        let item = null;
        return(
            this.props.routes && this.props.routes.map((route, i) =>  
            {  
                if (!route.isActive){
                    item = <BreadcrumbItem active={route.isActive} key={i}> <Link to={route.path}>{route.name}</Link> </BreadcrumbItem>;
                }
                else{
                    item = <BreadcrumbItem active={route.isActive} key={i}>{route.name}</BreadcrumbItem>;
                }

                return item;
            } 
            )              
        );
    }
    render(){
        return(
            <div>
                <Breadcrumb> {this.renderRoutes()} </Breadcrumb>
            </div>
        );
    }
}

BreadCrumbCompo.propTypes = {
    routes: Proptypes.array.isRequired
};


